<!--
 * @Author: Nie Wie
 * @Date: 2020-02-21 14:15:09
 * @LastEditors: Nie Wie
 * @LastEditTime: 2020-05-26 16:15:43
 * @Description: 新增、上云，景数、数据量，echarts图表
 -->
<template>
  <div class="observe-trend-total">
    <part-title title="新增数据态势"></part-title>
    <div class="observe-trend-total__chart">
      <!-- 按钮 -->
      <div class="observe-trend-total__switch-container">
        <span :class="['observe-trend-total__switch-btn', trendType === 'view' ? 'observe-trend-total__switch-btn--active' : null]" @click="chartChangeView('prev')">总景数</span>
        <span :class="['observe-trend-total__switch-btn', trendType === 'size' ? 'observe-trend-total__switch-btn--active' : null]" @click="chartChangeSize('next')">总数据量</span>
        <span class="observe-trend__select">{{periodSelect.title}}</span>
      </div>
      <!-- 左右 icon -->
      <div v-show="swiperIndex !== 0"
        class="observe-trend-total__switch-icon observe-trend-total__switch-icon--left"
        @click="chartChange('prev')">
      </div>
      <div v-show="swiperIndex !== 3"
        class="observe-trend-total__switch-icon observe-trend-total__switch-icon--right"
        @click="chartChange('next')">
      </div>
      <!-- echart 图表 -->
      <div class="observe-trend-total__chart-container swiper-container" ref="swiper-container">
        <div class="swiper-wrapper">
          <div class="observe-trend-total__chart-view swiper-slide" ref="dayViewChart"></div>
          <div class="observe-trend-total__chart-size swiper-slide" ref="daySizeChart"></div>
          <div class="observe-trend-total__chart-view swiper-slide" ref="weekViewChart"></div>
          <div class="observe-trend-total__chart-size swiper-slide" ref="weekSizeChart"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import Swiper from 'swiper'
// import 'swiper/css/swiper.css'
import PartTitle from '@/components/part-title'
import {
  GET_STATISTIC_HELP,
} from '@/assets/const-value/interface'

/**
 * 设置 moment 的语言环境
 */
moment.locale('fr', {
  week: {
    dow: 1, // 星期一是一周的第一天
    doy: 4, // 判断一年中的第一周
  },
})
const PERIOD_DATA = [{
  title: '日',
  value: 'day',
  key: 4,
}, {
  title: '周',
  value: 'week',
  key: 3,
}]
export default {
  components: {
    PartTitle,
  },
  data() {
    return {
      swiper: null,
      swiperIndex: 0,
      periodSelect: PERIOD_DATA[0],
      trendType: 'view', // 可选 'view','size'
      weekViewData: null,
      weekSizeData: null,
      dayViewData: null,
      daySizeData: null,
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initSwiper()
      this.$store.commit('page/SET_TREND_PERIOD', this.periodSelect)
      this.getData()
    })
  },
  methods: {
    initSwiper() {
      // eslint-disable-next-line no-new
      this.swiper = new Swiper(this.$refs['swiper-container'], {
        loop: false, // 循环
        observer: true, // 修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, // 修改swiper的父元素时，自动初始化swiper
        touchStartPreventDefault: false, // 添加该属性
        on: {
          slideChange: this.slideChange,
        },
      })
    },
    slideChange() {
      const { activeIndex } = this.swiper
      this.swiperIndex = activeIndex
      const periodIndex = Math.floor(activeIndex / 2)
      this.periodSelect = PERIOD_DATA[periodIndex]
      this.$store.commit('page/SET_TREND_PERIOD', this.periodSelect)

      this.trendType = activeIndex % 2 === 0 ? 'view' : 'size'
    },
    /**
     * @description: 切换图表
     * @param {type} String 控制切换方向，'prev','next'
     */
    chartChange(direction) {
      if (direction === 'next') {
        this.swiper.slideNext()
      } else {
        this.swiper.slidePrev()
      }
    },
    chartChangeView() {
      const { activeIndex } = this.swiper
      if (activeIndex % 2 === 1) {
        this.swiper.slidePrev()
      }
    },
    chartChangeSize() {
      const { activeIndex } = this.swiper
      if (activeIndex % 2 === 0) {
        this.swiper.slideNext()
      }
    },
    /**
     * @description: 获取图表数据
     */
    getData() {
      const year = moment().year()
      // const periodWeek8 = 8
      // const periodDay8 = 9
      const periodWeek = 4 // week
      const periodDay = 5
      const length = 8
      const lengthDay = 9
      const regionId = '-'
      const sateNames = {
        // 106: 'ZY1-02C',
        116: 'ZY1-02D',
        52: 'ZY1-02E',
        // 111: 'ZY3-01',
        115: 'ZY3-02',
        118: 'ZY3-03',
        7: '2m/8m星',
        109: 'GF-1',
        92: 'GF-2',
        55: 'GF-5A',
        54: 'GF-5B',
        91: 'GF-6',
        105: 'GF-7',
        119: 'CBERS-04A',
        122: 'L-SAR',
      }
      const satelliteIds = Object.keys(sateNames).toString() // '115,116,111,106,91, 96, 92,109,7,105'
      const taskType = 1
      const taskTypePush = 3

      const dayCloud = new Promise((resolve, reject) => {
        this.$axios.get(GET_STATISTIC_HELP, {
          params: {
            year, type: periodDay, length: lengthDay, regionId, satelliteIds: '19', taskType,
          },
        }).then(res => resolve(res)).catch(err => reject(err))
      })

      const dayPush = new Promise((resolve, reject) => {
        this.$axios.get(GET_STATISTIC_HELP, {
          params: {
            year, type: periodDay, length: lengthDay, regionId, satelliteIds: '19', taskType: taskTypePush,
          },
        }).then(res => resolve(res)).catch(err => reject(err))
      })

      const WeekCloud = new Promise((resolve, reject) => {
        this.$axios.get(GET_STATISTIC_HELP, {
          params: {
            year, type: periodWeek, length, regionId, satelliteIds: '19', taskType,
          },
        }).then(res => resolve(res)).catch(err => reject(err))
      })

      const WeekPush = new Promise((resolve, reject) => {
        this.$axios.get(GET_STATISTIC_HELP, {
          params: {
            year, type: periodWeek, length, regionId, satelliteIds: '19', taskType: taskTypePush,
            // year, type: periodWeek, length, regionId, satelliteIds, taskType: taskTypePush,
          },
        }).then(res => resolve(res)).catch(err => reject(err))
      })

      const pdayCloud = new Promise((resolve, reject) => {
        this.$axios.get(GET_STATISTIC_HELP, {
          params: {
            year, type: periodDay, length: lengthDay, regionId, satelliteIds, taskType,
          },
        }).then(res => resolve(res)).catch(err => reject(err))
      })

      const pdayPush = new Promise((resolve, reject) => {
        this.$axios.get(GET_STATISTIC_HELP, {
          params: {
            year, type: periodDay, length: lengthDay, regionId, satelliteIds, taskType: taskTypePush,
          },
        }).then(res => resolve(res)).catch(err => reject(err))
      })

      const pWeekCloud = new Promise((resolve, reject) => {
        this.$axios.get(GET_STATISTIC_HELP, {
          params: {
            year, type: periodWeek, length, regionId, satelliteIds, taskType,
          },
        }).then(res => resolve(res)).catch(err => reject(err))
      })

      const pWeekPush = new Promise((resolve, reject) => {
        this.$axios.get(GET_STATISTIC_HELP, {
          params: {
            year, type: periodWeek, length, regionId, satelliteIds, taskType: taskTypePush,
            // year, type: periodWeek, length, regionId, satelliteIds, taskType: taskTypePush,
          },
        }).then(res => resolve(res)).catch(err => reject(err))
      })
      Promise.all([ dayCloud, dayPush, WeekCloud, WeekPush, pdayCloud, pdayPush, pWeekCloud, pWeekPush ]).then((res) => {
        const [ ,,,, ...part2 ] = [ ...res ]
        this.$store.commit('page/SET_DATA_TREND', part2)
        const dayDataList = []
        res[0].data.forEach((sate) => {
          sate.data.sort((a, b) => a.period - b.period).forEach((periodData) => {
            const obj = {
              period: periodData.period,
              view: periodData.numCurrent,
              size: periodData.sizeCurrent,
              pushView: 0,
              pushSize: 0,
              startTime: moment(periodData.period, 'YYYYMMDD').format('MM-DD'),
              endTime: moment(periodData.period, 'YYYYMMDD').format('MM-DD'),
            }
            dayDataList.push(obj)
          })
        })

        res[1].data.forEach((sate) => {
          sate.data.sort((a, b) => a.period - b.period).forEach((periodData) => {
            const finder = dayDataList.find(i => i.period === periodData.period)
            if (finder) {
              finder.pushView += periodData.numCurrent
              finder.pushSize += periodData.sizeCurrent
            } else {
              const obj = {
                period: periodData.period,
                pushView: periodData.numCurrent,
                pushSize: periodData.sizeCurrent,
                view: 0,
                size: 0,
                startTime: moment(periodData.period, 'YYYYMMDD').format('MM-DD'),
                endTime: moment(periodData.period, 'YYYYMMDD').format('MM-DD'),
              }
              dayDataList.push(obj)
            }
          })
        })

        const weekDataList = []
        res[2].data.forEach((sate) => {
          sate.data.sort((a, b) => a.period - b.period).forEach((periodData) => {
            const finder = weekDataList.find(i => i.period === periodData.period)
            if (finder) {
              finder.view += periodData.numCurrent
              finder.size += periodData.sizeCurrent
            } else {
              const obj = {
                period: periodData.period,
                view: periodData.numCurrent,
                size: periodData.sizeCurrent,
                pushView: 0,
                pushSize: 0,
                startTime: moment(periodData.period, 'YYYYww').startOf('week').format('MM-DD'),
                endTime: moment(periodData.period, 'YYYYww').endOf('week').day(1).format('MM-DD'),
              }
              weekDataList.push(obj)
            }
          })
        })

        res[3].data.forEach((sate) => {
          sate.data.sort((a, b) => a.period - b.period).forEach((periodData) => {
            const finder = weekDataList.find(i => i.period === periodData.period)
            if (finder) {
              finder.pushView += periodData.numCurrent
              finder.pushSize += periodData.sizeCurrent
            } else {
              const obj = {
                period: periodData.period,
                pushView: periodData.numCurrent,
                pushSize: periodData.sizeCurrent,
                view: 0,
                size: 0,
                startTime: moment(periodData.period, 'YYYYww').startOf('week').format('MM-DD'),
                endTime: moment(periodData.period, 'YYYYww').endOf('week').day(1).format('MM-DD'),
              }
              weekDataList.push(obj)
            }
          })
        })
        if (dayDataList.length) this.setDayChartOption(dayDataList)
        if (weekDataList.length) this.setWeekChartOption(weekDataList)
      })
    },
    setDayChartOption(dayDataList) {
      const coverInfo = dayDataList.sort((a, b) => a.startTime - b.startTime)
      const dayViewData = {
        Axis: [],
        newData: [],
        push: [],
      }
      const daySizeData = {
        Axis: [],
        newData: [],
        push: [],
      }
      coverInfo.forEach((item) => {
        dayViewData.Axis.push(item.endTime)
        dayViewData.newData.push(item.view)
        dayViewData.push.push(item.pushView)
        daySizeData.Axis.push(item.endTime)
        daySizeData.newData.push(parseFloat((item.size / 1024 / 1024 / 1024 / 1024).toFixed(2)))
        daySizeData.push.push(parseFloat((item.pushSize / 1024 / 1024 / 1024 / 1024).toFixed(2)))
      })
      this.initViewChart(dayViewData, 'dayViewChart', 'day')
      this.initSizeChart(daySizeData, 'daySizeChart', 'day')
    },
    setWeekChartOption(weekDataList) {
      const coverInfo = weekDataList.sort((a, b) => a.startTime - b.startTime)
      const weekViewData = {
        Axis: [],
        newData: [],
        push: [],
      }
      const weekSizeData = {
        Axis: [],
        newData: [],
        push: [],
      }
      weekViewData.Axis.push(coverInfo[0].startTime)
      weekSizeData.Axis.push(coverInfo[0].startTime)
      coverInfo.forEach((item) => {
        weekViewData.Axis.push(item.endTime)
        weekViewData.newData.push(item.view)
        weekViewData.push.push(item.pushView)
        weekSizeData.Axis.push(item.endTime)
        weekSizeData.newData.push(parseFloat((item.size / 1024 / 1024 / 1024 / 1024).toFixed(2)))
        weekSizeData.push.push(parseFloat((item.pushSize / 1024 / 1024 / 1024 / 1024).toFixed(2)))
      })
      this.initViewChart(weekViewData, 'weekViewChart')
      this.initSizeChart(weekSizeData, 'weekSizeChart')
    },
    /**
     * @description: 设定配置项
     */
    initViewChart(chartData, domRef, isDay) {
      const yAxisName = '( 景 )'
      const legendData = [ '上云', '推送' ]
      const colors = [ '#F74C32', '#29B7A3', 'rgba(247, 76, 50, 0.1)', 'rgba(41, 183, 163, 0.1)' ]
      const option = this.getOption({
        yAxisName, legendData, chartData, colors, isDay,
      })

      const chartView = this.$echarts.init(this.$refs[domRef])
      chartView.setOption(option)
    },
    initSizeChart(chartData, domRef, isDay) {
      const yAxisName = '( T )'
      const legendData = [ '上云', '推送' ]
      const colors = [ '#7A73FF', '#EB4DDB', 'rgba(122, 115, 255, 0.1)', 'rgba(235, 77, 219, 0.1)' ]
      const option = this.getOption({
        yAxisName, legendData, chartData, colors, isDay,
      })

      const chartSize = this.$echarts.init(this.$refs[domRef])
      chartSize.setOption(option)
    },
    getOption({
      yAxisName, legendData, chartData, colors, isDay,
    }) {
      const xAxisData = [ ...chartData.Axis ]
      xAxisData.pop()
      return {
        legend: {
          data: legendData,
          right: 30,
          top: 0,
          textStyle: {
            fontFamily: 'PingFangSC-Regular,PingFang SC',
            fontSize: 16,
            color: '#737373',
            padding: [ 5, 0, 0, 0 ],
          },
          itemWidth: 20,
          itemHeight: 12,
        },
        color: colors,
        grid: {
          top: 50,
          right: 35,
          left: 90,
          bottom: 90,
        },
        xAxis: [{
          type: 'category',
          data: chartData.Axis,
          axisLine: {
            show: true,
          },
          axisTick: {
            show: true,
            // alignWithLabel: true,
          },
          boundaryGap: false,
          axisLabel: {
            color: '#737373',
            // rotate: 45,
            margin: 15,
            textStyle: {
              fontSize: 16,
              fontFamily: 'PingFangSC-Regular,PingFang SC',
            },
          },
        }, {
          type: 'category',
          data: xAxisData,
          axisTick: {
            show: false,
            alignWithLabel: true,
          },
          axisLabel: false,
          axisLine: false,
        }],
        yAxis: {
          name: yAxisName,
          nameTextStyle: {
            fontSize: 16,
            color: '#737373',
            align: 'right',
            padding: [ 0, 5, 10, 0 ],
          },
          boundaryGap: false,
          axisLabel: {
            color: '#737373',
            textStyle: {
              fontSize: 16,
              fontFamily: 'PingFangSC-Regular,PingFang SC',
            },
          },
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#EFEFEF',
            },
          },
        },
        series: [{
          type: 'line',
          name: legendData[0],
          xAxisIndex: isDay ? 0 : 1,
          data: chartData.newData,
          smooth: true,
          label: {
            normal: {
              show: true,
              color: colors[0],
              backgroundColor: colors[2],
              borderRadius: 20,
              fontFamily: 'PingFangSC-Regular,PingFang SC',
              align: 'center',
              position: 'top',
              padding: [ 3, 5, 0, 5 ],
            },
          },
        }, {
          type: 'line',
          name: legendData[1],
          xAxisIndex: isDay ? 0 : 1,
          data: chartData.push,
          smooth: true,
          label: {
            normal: {
              show: true,
              color: colors[1],
              backgroundColor: colors[3],
              borderRadius: 20,
              align: 'center',
              position: 'top',
              padding: [ 3, 5, 0, 5 ],
            },
          },
        }],
      }
    },
  },
}
</script>

<style lang="scss">
.observe-trend-total {
  position: relative;
  padding: 0 35px;
  margin-bottom: 40px;
}
.observe-trend-total__chart {
  border-radius: 12px;
  box-shadow: 0 0 10px rgba(0,0,0,.2);
}

// 按钮
.observe-trend-total__switch-container {
  padding: 30px 25px;
  padding-bottom: 10px;
  font-family: PingFangSC-Medium,PingFang SC;
  font-size: 20px;
  font-weight: 500;
  color: #666;
}
.observe-trend-total__switch-btn {
  margin-right: 30px;
  &:hover {
    cursor: pointer;
  }
}
.observe-trend-total__switch-btn--active {
  font-size: 28px;
  color: #005EFF;
}

.observe-trend__select {
  position: absolute;
  right: 66px;
  width: 56px;
  height:34px;
  display: inline-block;
  text-align: center;
  background:rgba(241,245,255,1);
  border-radius:12px;
  border:1px solid rgba(204,222,255,1);
  font-size:20px;
  font-family:PingFangSC-Light,PingFang SC;
  font-weight:300;
  color:rgba(0,94,255,1);
  // &:hover {
  //   cursor: pointer;
  // }
}
.observe-trend-total__switch-icon {
  position: absolute;
  width: 50px;
  height: 50px;
  top: 52%;
  background-image: url(../../../assets/images/right.png);
  cursor: pointer;
  z-index: 2;
}
.observe-trend-total__switch-icon--left {
  left: 10px;
  transform: rotate(180deg);
}
.observe-trend-total__switch-icon--right {
  right: 10px;
}

.observe-trend-total__chart-container {
  height: 370px;
  position: relative;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  div {
    width: 100%;
    height: 100%;
    display: inline-block;
  }
}
</style>
